import { isGlobalworth, paths } from 'config'
import { Loadable } from 'shared/components'
import { ModuleRoute } from 'shared/types'
import {
  Board,
  Booking,
  Car,
  Desk,
  DrawerCalendar,
  DrawerDesk,
  DrawerMeetingRoom,
  DrawerParking,
  DrawerOther,
  DrawerSauna,
} from 'shared/assets'
import { Locker } from 'shared/assets/globalworth'
import { BookingPaths } from './utils'

const routes: ModuleRoute[] = [
  {
    path: paths.parkingSpots,
    exact: true,
    linkSettings: {
      icon: isGlobalworth ? Booking : DrawerCalendar,
      label: 'nav.booking',
    },
    component: Loadable({
      component: () => import('./pages/ParkingSpots'),
    }),
    subroutes: [
      {
        path: BookingPaths.PARKING_SPOTS,
        exact: true,
        linkSettings: {
          icon: isGlobalworth ? Car : DrawerParking,
          label: 'nav.parkingSpots',
        },
        component: Loadable({
          component: () => import('./pages/ParkingSpots'),
        }),
      },
      {
        path: BookingPaths.CONFERENCE_ROOMS,
        exact: true,
        linkSettings: {
          icon: isGlobalworth ? Board : DrawerMeetingRoom,
          label: 'nav.conferenceRooms',
        },
        component: Loadable({
          component: () => import('./pages/ConferenceRooms'),
        }),
      },
      {
        path: BookingPaths.DESKS,
        exact: true,
        linkSettings: {
          icon: isGlobalworth ? Desk : DrawerDesk,
          label: 'nav.desks',
        },
        component: Loadable({
          component: () => import('./pages/Desks'),
        }),
      },
      ...(isGlobalworth
        ? [
            {
              path: BookingPaths.LOCKERS,
              exact: true,
              linkSettings: {
                icon: Locker,
                label: 'nav.lockers',
              },
              component: Loadable({
                component: () => import('./pages/Lockers'),
              }),
            },
          ]
        : []),
      ...(!isGlobalworth
        ? [
            {
              path: BookingPaths.OTHER,
              exact: true,
              linkSettings: {
                icon: DrawerOther,
                label: 'nav.other',
              },
              component: Loadable({
                component: () => import('./pages/Other'),
              }),
            },
            {
              path: BookingPaths.SAUNAS,
              exact: true,
              linkSettings: {
                icon: DrawerSauna,
                label: 'nav.saunas',
              },
              component: Loadable({
                component: () => import('./pages/Saunas'),
              }),
            },
          ]
        : []),
    ],
  },
]

export default routes
